module.exports = __webpack_public_path__ + "img/transfer11.c352ed2f.jpeg";